import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Subject as RxSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CardComponent } from '../../../ui/card/card.component';
import { StudentSessionsTabComponent } from '../../../../shared/tables/student-sessions-tab/student-sessions-tab.component';

@Component({
  selector: 'app-following',
  standalone: true,
  imports: [TranslateModule, CommonModule, CardComponent, StudentSessionsTabComponent],
  templateUrl: './following.component.html',
  styleUrl: './following.component.css',
})
export class FollowingComponent implements OnInit, OnDestroy {
  private translate = inject(TranslateService);
  private destroy$ = new RxSubject<void>();

  isLTR = false;

  ngOnInit(): void {
    this.isLTR = this.translate.currentLang !== 'ar';
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((e) => (this.isLTR = e.lang !== 'ar'));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
